import { css } from '@emotion/react';

export const countLoader = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  gap: var(--fabric-geometry-compact-space-gap-sm);
`;
